import { createSelector } from 'reselect';

import { State } from '../../interfaces/State';
import { NotesState } from '../reducers/notes';

export const selectNotes = (state: State): NotesState => state.get('notes');

export const selectWorkspaceTemplate = createSelector(
  selectNotes,
  (notesState) => notesState.workspaceTemplate,
);

export const showNoteTaking = createSelector(
  selectWorkspaceTemplate,
  (workspaceTemplate) => workspaceTemplate != null,
);
